/// <reference path="../../types.d.ts" />

export const selectAutomationDashboard = (
  state: CMx.ApplicationState
): CMx.AutomationDashboardState => state.automationDashboard;
